// extracted by mini-css-extract-plugin
export default {"gridContainer":"BusinessList_gridContainer__dj4Bc"};